export enum FleetClassification {
  Fleet = 'FLEET',
  Rental = 'RENTAL',
  Freelancer = 'FREELANCER',
}
